<template>
  <v-container class="px-0 pt-3">
    <v-skeleton-loader
      class="ml-6 my-6"
      v-if="self.selfPending"
      type="heading"
    ></v-skeleton-loader>
    <v-row no-gutters class="px-6 pt-2" v-else>
      <v-col align-self="center">
        <v-row no-gutters class="text-h4 font-weight-bold">
          <v-col
            cols="auto"
            align-self="center"
            class="main-font secondary--text"
            @click="$router.push(`/garden/${gardenId}`).catch(() => {})"
            >{{ nameGarden }}
          </v-col>
          <v-col
            cols="auto"
            v-if="!visitor && !$route.path.includes('/explore/')"
            align-self="center"
            class="pl-5"
          >
            <label for="add-plant">
              <v-icon color="primary" size="30" class="mt-n1"
                >mdi-camera-plus-outline</v-icon
              >
            </label>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="auto" align-self="center" style="max-height: 36px">
        <v-badge
          top
          color="error"
          dot
          offset-x="10"
          offset-y="10"
          bordered
          :value="toUpdate && !visitor"
        >
          <v-img
            class="shrink rounded-circle"
            :src="visitor ? user.profilePictureUrl : self.profilePictureUrl"
            transition="fade-transition"
            height="40"
            width="40"
            @click="
              visitor
                ? $store.commit(
                    'fullScreenPicture/setUrl',
                    user.profilePictureUrl
                  )
                : $router.push('/profile')
            "
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-icon size="30" color="primary">mdi-account-outline</v-icon>
              </v-row>
            </template>
          </v-img></v-badge
        >
      </v-col>
    </v-row>

    <v-row
      no-gutters
      class="text-grey text-body-1 mx-6"
      style="opacity: 0.55"
      v-if="plants.length > 1"
    >
      ({{ visitor ? "" : "You have" }} {{ plants.length }} plants)
    </v-row>

    <template v-if="plantsPending">
      <div class="container-columns px-6" style="min-height: 312px">
        <v-skeleton-loader
          type="image"
          class="rounded-xl my-4 mr-4"
          v-for="n in 3"
          :key="n"
          height="200"
          width="160"
          style="display: inline-block; vertical-align: top; position: relative"
        ></v-skeleton-loader></div
    ></template>
    <template v-else-if="plants.length > 0">
      <div class="container-columns px-6 pt-2">
        <transition-group name="move-right">
          <Plant
            v-for="plant in plants"
            :key="plant.id"
            :plant="plant"
            :self="self"
            @toggleLove="toggleLove"
          />
        </transition-group>
      </div>
    </template>
    <template v-else>
      <v-row no-gutters justify="center" class="mt-10">
        <v-img
          alt="empty pots"
          class="shrink"
          src="/img/illustrations/pots.svg"
          style="filter: grayscale(1); opacity: 0.5"
          transition="scale-transition"
          width="110"
          height="100"
          contain
      /></v-row>
      <v-row no-gutters justify="center" class="mt-2 text-caption grey--text">
        No plant yet
      </v-row>
      <v-row no-gutters justify="center" class="mb-3">
        <label
          v-if="!visitor"
          for="add-plant"
          class="py-1 rounded-pill v-btn white--text px-4 my-6 text-none"
          style="background-color: var(--v-primary-base); height: 36px"
        >
          Add my first plant
        </label>
      </v-row>
    </template>
    <input
      type="file"
      id="add-plant"
      @change="onFileChange"
      accept="image/*"
      style="display: none"
    />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import resizePicture from "@/utils/resizePicture.js";
import Plant from "./Plant.vue";

export default {
  name: "Plants",
  components: {
    Plant,
  },
  computed: {
    gardenId() {
      return this.$route.params.gardenId;
    },
    visitor() {
      return this.gardenId !== this.self.id;
    },
    ...mapState("update", ["toUpdate"]),
    ...mapState("users", ["user"]),
    ...mapState("self", ["self", "selfPending"]),
    ...mapState("plants", ["plantsPending"]),
    plants() {
      return this.$store.state.plants.plants.filter(function (i) {
        return !i.status;
      });
    },
    nameGarden() {
      if (this.visitor) {
        return this.user.nickname ? `${this.user.nickname}'s garden` : "Garden";
      } else {
        return "My Garden";
      }
    },
  },
  methods: {
    toggleLove(params, item) {
      if (item.loversId.includes(this.self.id)) {
        item.loversId = item.loversId.filter((i) => {
          return i !== this.self.id;
        });
      } else {
        item.loversId.push(this.self.id);
      }
      this.$store.dispatch("lovers/toggleLove", params);
    },
    async onFileChange(e) {
      try {
        const dataurl = await resizePicture(e.target.files[0], 1000, 1000);
        this.$store.dispatch("level/updateLevel", {
          field: "plant",
          value: true,
        });
        this.$store.dispatch("plants/uploadPlantPicture", { picture: dataurl });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style >
/* * {
  border: solid 1px red;
} */
.menu-dropdown {
  background-color: #333333cc;
}

.container-columns {
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}
.container-columns::-webkit-scrollbar {
  height: 10px;

  color: var(--v-primary-base) !important;
}
.container-columns::-webkit-scrollbar-track {
  border-radius: 10px;
  margin-left: 30px;
  margin-right: 30px;
}
.container-columns::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(194, 194, 194, 0.2);
}

.move-right-item {
  transition: all 0.5s;
}
.move-right-enter,
.move-right-leave-to {
  opacity: 0;
  transform: translateX(-50px);
}
.move-right-leave-active {
  position: absolute;
  z-index: -1;
}
</style>